import { Grid, TextField } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    color: theme.palette.text.primary,
  },
  '& label': {
    color: theme.palette.text.secondary,
  },
  '& label.Mui-focused': {
    color: theme.palette.info.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[600],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.info.main,
    },
  },
}));

function PositionForm({ formData, handleChange }) {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12}>
        <StyledTextField
          fullWidth
          label="المسمى الوظيفي"
          name="name"
          value={formData.name}
          onChange={(e) => handleChange({ ...formData, name: e.target.value })}
          required
          placeholder="أدخل المسمى الوظيفي"
        />
      </Grid>
    </Grid>
  );
}

PositionForm.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default PositionForm;
